module.exports = __webpack_public_path__ + "static/media/corporateStep4.0130b01f.svg";